<template>
  <div ref="root">
    <div class="post-index-filters">
      <div class="post-index-sort-row">
        <div class="post-index-search-panel">
          <button
            class="bare-btn btn-post-search-open"
            @click="openSearch"
          ></button>
          <div class="post-index-search-container">
            <input
              v-model="search_query"
              type="search"
              id="post-search"
              name="q"
              size="20"
              placeholder="Search..."
              autocomplete="off"
              @keydown.enter="updateSearch($event)"
            />
            <button
              class="btn-close btn-post-search-close"
              data-skin="light"
              @click="clearSearch"
            >
              <div class="sr-only">Close Search</div>
              <span class="btn-close-icon">
                <span class="btn-close-icon-bar"></span>
                <span class="btn-close-icon-bar"></span>
                <span class="btn-close-icon-bar"></span>
              </span>
            </button>
          </div>
        </div>
      </div>

      <div class="post-index-input-row">
        <button class="post-filter-trigger" @click="showFilterList($event)">
          <span class="label">Filter by</span>
          <div class="pft-icon">
            <span class="pft-icon-bar"></span>
            <span class="pft-icon-bar"></span>
            <span class="pft-icon-bar"></span>
          </div>
        </button>
        <button
          class="post-filter-clear-trigger"
          @click="clearFilterList($event)"
        >
          <div class="pft-icon">
            <span class="pft-icon-bar"></span>
            <span class="pft-icon-bar"></span>
            <span class="pft-icon-bar"></span>
          </div>
        </button>

        <div class="post-index-input-panel">
          <div class="post-index-input-container">
            <h4>Filter by</h4>
            <button
              class="btn-close btn-close-filter-panel"
              aria-label="close"
              data-skin="light"
              @click="hideFilterList($event)"
            >
              <div class="sr-only">Close Filter Panel</div>
              <span class="btn-close-icon">
                <span class="btn-close-icon-bar"></span>
                <span class="btn-close-icon-bar"></span>
                <span class="btn-close-icon-bar"></span>
              </span>
            </button>

            <div class="post-index-input-filter-container">
              <div
                v-for="filter in filters.list"
                :key="filter.label"
                role="region"
                class="post-filter-container"
                aria-label="filters with selected terms"
              >
                <label class="uppercase post-filter-tax">{{
                  filter.label
                }}</label>
                <div
                  :id="'post-filter-' + filter.taxonomy"
                  class="post-filter-list-container"
                  role="region"
                >
                  <ul class="post-filter-list">
                    <li v-for="term in filter.terms" :key="term.id">
                      <input
                        class="sr-only"
                        type="checkbox"
                        :value="term.term_id"
                        :id="term.slug"
                        :name="filter.taxonomy"
                        :checked="term.selected"
                        @click="
                          updateTerms(
                            filter.taxonomy,
                            term.term_id,
                            term.name,
                            $event
                          )
                        "
                      />
                      <label :for="term.slug" v-html="term.name"></label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, onMounted } from "vue";

export default {
  props: ["filters", "posttype"],
  setup(props, context) {
    const root = ref(null);
    const filters = reactive(props.filters);
    let search_query = ref("");
    let order_query = "DESC";
    let orderby_query;
    let searchInput;
    let searchClose;
    let filterTrigger;
    let clearTrigger;
    let selectedTerm;
    let selectedTermLabel;
    let searchOpenBtn;
    let searchCloseBtn;
    let panel;
    let filterLists;
    let parent;

    onMounted(() => {
      panel = root.value.querySelector(".post-index-filters");
      searchInput = root.value.querySelector("#post-search");
      searchClose = root.value.querySelector(".post-search-close");
      searchOpenBtn = root.value.querySelector(".btn-post-search-open");
      filterLists = root.value.querySelectorAll(".post-filter-container");
      filterTrigger = root.value.querySelector(".post-filter-trigger");
      clearTrigger = root.value.querySelector(".post-filter-clear-trigger");
      selectedTermLabel = root.value.querySelector(
        ".post-filter-trigger .label"
      );
      parent = document.querySelector("#vue-post-index");
    });

    const toggleFilterList = (e) => {
      const isExpanded = e.currentTarget.getAttribute("aria-expanded");

      e.currentTarget.setAttribute(
        "aria-expanded",
        isExpanded === "true" ? false : true
      );
    };

    const showFilterList = (e) => {
      panel.classList.add("filter-enabled");

      if (panel.classList.contains("search-enabled")) {
        panel.classList.remove("search-enabled");
      }

      if(search_query.value) {
        search_query.value = '';
        updateSearch();
      }

      //   if (e.currentTarget.classList.contains("filtered")) {
      //     // reset term
      //     context.emit("update-terms", {
      //       taxonomy: selectedTerm.name,
      //       term_id: selectedTerm.value,
      //       selected: false,
      //     });

      //     selectedTerm.checked = false;

      //     filterTrigger.classList.remove("filtered");
      //     selectedTermLabel.innerHTML = "Filter by";
      //     selectedTerm = undefined;
      //   } else {
      //     panel.classList.add("filter-enabled");
    };

    const clearFilterList = (e) => {
      if (selectedTerm) {
        context.emit("update-terms", {
          taxonomy: selectedTerm.name,
          term_id: selectedTerm.value,
          selected: false,
        });

        selectedTerm.checked = false;
      } else {
        context.emit("update-terms", {
          taxonomy: false,
          term_id: false,
          selected: false,
        });

        // uncheck checked checkbox
        const checkboxes = parent.querySelectorAll(`input[type=checkbox]`);

        checkboxes.forEach((c) => {
          c.checked = false;
        });
      }

      filterTrigger.classList.remove("filtered");
      clearTrigger.classList.remove("show");
      selectedTermLabel.innerHTML = "Filter by";
      selectedTerm = undefined;
    };

    const hideFilterList = (e) => {
      // const triggerBtn = e.currentTarget.querySelector(".post-filter-trigger");
      // triggerBtn.setAttribute("aria-expanded", false);
      panel.classList.remove("filter-enabled");
    };

    const hideAllFilterList = () => {
      filterLists.forEach((list) => {
        const triggerBtn = list.querySelector(".post-filter-trigger");
        triggerBtn.setAttribute("aria-expanded", false);
      });
    };

    /**
     * terms
     */
    const updateTerms = (taxonomy, term_id, term_name, e) => {
      // const triggers = parent.querySelectorAll(
      //   `.post-filter-trigger[data-taxonomy='${taxonomy}']`
      // );

      // uncheck other checkboxes. forced to act like radio buttons
      if (e.currentTarget.checked) {
        // const checkboxes = parent.querySelectorAll(`input[name='${taxonomy}']`);
        const checkboxes = parent.querySelectorAll(
          ".post-index-input-filter-container input[type='checkbox']"
        );

        checkboxes.forEach((c) => {
          if (c.value != term_id) {
            c.checked = false;
          } else {
            c.checked = true;
          }
        });

        filterTrigger.classList.add("filtered");
        clearTrigger.classList.add("show");
        selectedTerm = e.currentTarget;
        selectedTermLabel.innerHTML = term_name;

        panel.classList.remove("filter-enabled");

        // triggers.forEach((trigger) => {
        //   trigger.innerHTML = `<span>${term_name}</span>`;
        // });
      } else {
        filterTrigger.classList.remove("filtered");
        clearTrigger.classList.remove("show");
        selectedTermLabel.innerHTML = "Filter by";
        selectedTerm = undefined;
      }

      // else {
      //   triggers.forEach((trigger) => {
      //     trigger.innerHTML = "<span>All</span>";
      //   });
      // }

      context.emit("update-terms", {
        taxonomy,
        term_id,
        selected: e.currentTarget.checked,
      });
    };

    /**
     * reset terms of the taxonomy
     */
    const resetTerms = (taxonomy, e) => {
      const triggers = parent.querySelectorAll(
        `.post-filter-trigger[data-taxonomy='${taxonomy}']`
      );

      const checkboxes = parent.querySelectorAll(`input[name='${taxonomy}']`);

      checkboxes.forEach((c) => {
        c.checked = false;
      });

      e.currentTarget.checked = true;

      triggers.forEach((trigger) => {
        trigger.innerHTML = "<span>All</span>";
      });

      context.emit("reset-terms", {
        taxonomy,
      });
    };

    /**
     * sort
     */
    const updateSort = (post, e) => {
      // orderby=date&order=${order_query}
      // orderby=title&order=${order_query}

      orderby_query = "date";
      order_query = e.currentTarget.classList.toggle("toggle") ? "ASC" : "DESC";
      e.currentTarget.textContent = order_query === "ASC" ? "Latest" : "Oldest";

      context.emit("update-sort", order_query, orderby_query);
    };

    /**
     * search
     */
    const openSearch = (e) => {
      if (panel.classList.contains("filter-enabled")) {
        panel.classList.remove("filter-enabled");
      }
      panel.classList.add("search-enabled");
    };

    const updateSearch = (e) => {
      context.emit("update-search", search_query.value);

      // clear term
      clearFilterList();
    };

    const clearSearch = (e) => {
      panel.classList.remove("search-enabled");
      searchInput.value = "";
      search_query.value = "";
      context.emit("update-search", search_query.value);
      // searchKeyUpHandler();
    };

    const searchKeyUpHandler = () => {
      searchClose.style.display =
        searchInput.value.length > 0 ? "block" : "none";
    };

    /**
     * UX and a11y
     */
    // Collapse the dropdown container when Escape key is pressed.
    const keyDownHandler = (e) => {
      const trigger = e.currentTarget.querySelector(".post-filter-trigger");

      var isExpanded =
        trigger.getAttribute("aria-expanded") === "true" ? true : false;

      if (e.key === "Escape" && isExpanded) {
        trigger.setAttribute("aria-expanded", false);
        trigger.focus();
      }
    };

    // Collapse the dropdown container when outside of the filter container clicked
    document.addEventListener("click", (e) => {
      const triggers = root.value.querySelectorAll(".post-filter-trigger");

      triggers.forEach((trigger) => {
        const isExpanded =
          trigger.getAttribute("aria-expanded") === "true" ? true : false;

        if (
          !trigger.nextSibling.contains(e.target) &&
          !trigger.contains(e.target) &&
          trigger != e.target &&
          isExpanded
        ) {
          trigger.setAttribute("aria-expanded", false);
        }
      });
    });

    return {
      root,
      filters,
      search_query,
      updateTerms,
      resetTerms,
      updateSort,
      updateSearch,
      clearSearch,
      openSearch,
      // searchKeyUpHandler,
      toggleFilterList,
      showFilterList,
      clearFilterList,
      hideFilterList,
      keyDownHandler,
    };
  },
};
</script>
